// Package quotes groups
export const PACKAGE_QUOTES = {
  GROUP: {
    MOVERS_ONLY: 'MOVERS_ONLY',
    MOVERS_WITH_TRUCK: 'MOVERS_WITH_TRUCK',
    TRUCK_ONLY: 'TRUCK_ONLY',
  },
};

// Package quotes service IDs
export const SERVICE_IDS = {
  LOADING: 'LOADING',
  LOADINGUNLOADING: 'LOADINGUNLOADING',
  TRANSIT: 'TRANSIT',
  UNLOADING: 'UNLOADING',
};
